import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import remark from 'remark';
import remarkHtml from 'remark-html';
import markdown from 'remark-parse';

import { HTMLContent } from '../Content';
// eslint-disable-next-line import/no-relative-packages
import { remarkATitle } from '../../../plugins/gatsby-remark-a-title';
// eslint-disable-next-line import/no-relative-packages
import { remarkExternalLinks } from '../../../plugins/gatsby-remark-voteamerica-external-links';

const markdownProcessor = remark()
  .use(markdown, { gfm: true })
  .use(remarkExternalLinks, { rel: ['noopener'] })
  .use(remarkATitle)
  .use(remarkHtml);

export default function Markdown({ content }) {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    setHtml(markdownProcessor.processSync(content).contents);
  }, [content]);

  if (!html) {
    return null;
  }

  return <HTMLContent content={html} />;
}

Markdown.propTypes = {
  content: PropTypes.string,
};
